const getFulfilmentIds = ({ source, seller }) => {
  const sellerId = seller?.id || null;
  const sourceId = source?.id || null;

  return { sourceId, sellerId };
};

export default getFulfilmentIds;
